import numeral from 'numeral';
import { convertToTonne, UNIT_KILOGRAM_SYMBOL, UNIT_METRIC_TONNE_SYMBOL } from './unitConverter';

// ----------------------------------------------------------------------

export function fCurrency(number: string | number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number: string | number) {
  return numeral(number).format('0.0 b');
}

export function fNumberWith2Decimals(number: number) {
  return number.toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export const getRoundedNumber = (num?: number) => {
  if (num && !isNaN(num)) {
    return Math.round(num).toLocaleString();
  } else return 0;
}

export const convertNumberToLocale = (data: any) => {
  const MAX_NUMBER = 1000000000;

  if (data?.unit && data?.value) {
    const symbol = data?.unit?.toLowerCase();

    if (data?.value >= MAX_NUMBER && symbol === UNIT_KILOGRAM_SYMBOL) {
      const valueToTonne = convertToTonne(data?.value, symbol);
      if (valueToTonne) {
        return `${getRoundedNumber(valueToTonne)} ${UNIT_METRIC_TONNE_SYMBOL.toLowerCase()}`;
      }
    } else {
      return `${getRoundedNumber(data?.value)} ${symbol}`;
    }
  }

  if (!isNaN(data)) {
    return getRoundedNumber(data);
  } else return '-';
};
